<script>
import ProInput from '$common/ProInput'
import copy from './StudentConductAndPolicy.js'
const contactTypes = ['primary_contact', 'secondary_contact']
export default {
  name: 'Paperwork',
  components: {
    'pro-input': ProInput,
  },
  props: {
    options: {
      required: true,
    },
  },
  watch: {
    'studentForms.0.emergency_contact.name': {
      handler (newVal) {
        if (newVal !== 'wowz') return

        this.agreesToConductAndPolicy = true

        this.students.forEach((_, studentIdx) => {
          this.studentForms[studentIdx] = {
            //phone: ['5743121467', '5745362226', '7654567789'][studentIdx],
            //address: '14671 Co Rd 40, Goshen, IN, 46528',
            ...this.$clone([/*...contactTypes*/'emergency_contact'].reduce((acc, contactType, idx) => { //cloning because it was copying answers to other students before
              acc[contactType] = {
                name: ['Gregory Mullet', 'Sarah Mullet'][idx],
                relationship: ['Uncle', 'Aunt'][idx],
                home_phone: '5743121467',
                cell_phone: '5743121467',
                work_phone: '5743121467',
                email: 'jorymullet@gmail.com',
              }
              return acc
            }, {})),
            emergency_comments: ['They are doing great', 'Two weeks to live', 'Wow they are tall'][studentIdx],
            //allergies: ['None', 'Peanuts', ''][studentIdx],
            media_use_permission: true,
            media_liability_release: true,
            /*allowed_pickups: Array(2).fill(0).map((_, idx) => ({
              name: ['Grey Thomas', 'Wow Town'][idx],
              phone: ['1231231234', '5431231221'][idx],
              relationship: ['Friend of the family', 'Second cousin'][idx],
            })),*/
            //self_signout: false,
          }
        })

        this.$forceUpdate()
      },
    },
  },  
  data () {
    return {
      copy,
      guardian: null,
      students: [],
      studentForms: [],
      agreesToConductAndPolicy: false,
      studentFormTemplate: {
        emergency_contact: {
          name: '',
          relationship: '',
          home_phone: '',
          cell_phone: '',
          work_phone: '',
          email: '',
        },
        emergency_comments: '',
        media_use_permission: null,
        media_liability_release: false,
      },
      /*studentFormTemplate: {
        phone: '',
        address: '',
        ...this.$clone(contactTypes.reduce((acc, contactType) => { //cloning because it was copying answers to other students before
          acc[contactType] = {
            name: '',
            relationship: '',
            home_phone: '',
            cell_phone: '',
            work_phone: '',
          }
          return acc
        }, {})),
        emergency_comments: '',
        allergies: '',
        media_released: false,
        allowed_pickups: Array(2).fill(0).map(_ => ({
          name: '',
          phone: '',
          relationship: '',
        })),
        self_signout: false,
      },*/
      formOptions: {
        phone: student => ({
          title: `${student.name}'s phone`,
          errorIf: val => !val || this.$regex.is(val).a('phone') ? '' : 'Enter valid phone number',
          type: 'phone',
        }),
        address: student => ({
          title: this.seeFields.address ? `${student.name}'s address` : 'Address',
          errorIf: val => val ? '' : 'Enter address',
        }),
        .../*contactTypes*/['emergency_contact'].reduce((acc, contactType) => {
          acc[contactType] = {
            name: student => ({
              title: 'Name',
              errorIf: val => val ? '' : `Enter name`,
            }),
            relationship: student => ({
              title: 'Relationship',
              errorIf: val => val ? '' : `Enter relationship`,
            }),
            cell_phone: student => ({
              title: `Cell phone`,
              errorIf: val => this.$regex.is(val).a('phone') ? '' : 'Enter valid cell number',
              type: 'phone',
            }),
            home_phone: student => ({
              title: `Home phone`,
              errorIf: val => !val || this.$regex.is(val).a('phone') ? '' : 'Enter valid home number',
              type: 'phone',
            }),
            work_phone: student => ({
              title: `Work phone`,
              errorIf: val => !val || this.$regex.is(val).a('phone') ? '' : 'Enter valid work number',
              type: 'phone',
            }),
            email: student => ({
              title: 'Email',
              errorIf: val => this.$regex.is(val).an('email') ? '' : 'Enter valid email.',
              type: 'email',
            }),
          }
          return acc
        }, {}),
        emergency_comments: student => ({
          title: `${student.name}'s notes`,
          errorIf: val => '',
        }),
        allergies: student => ({
          title: `${student.name}'s allergies`,
          errorIf: val => '',
        }),
        allowed_pickups: Array(2).fill().map(_ => ({
          name: () => ({
            title: 'Name',
            errorIf: val => val ? '' : 'Enter name of person allowed to pickup student',
          }),
          phone: () => ({
            title: `Phone number`,
            errorIf: val => this.$regex.is(val).a('phone') ? '' : 'Enter valid phone number',
            type: 'phone',
          }),
          relationship: () => ({
            title: 'Relationship to student',
            errorIf: val => val ? '' : 'Enter relationship to student',
          }),
        })),
      },
      // determines if we see indivual or duplicated fields for the students
      seeFields: {
        address: false,
        emergencyContact: false,
        primaryEmergency: false,
        secondaryEmergency: false,
        allowedPickups: false,
      },
      // list the emergency types to keep pug dry in form
      emergencyTypes: [
        /*{
          name: 'primary',
          capital: 'Primary',
          camel: 'primaryEmergency',
          abbr: 'PEC',
        },
        {
          name: 'secondary',
          capital: 'Secondary',
          camel: 'secondaryEmergency',
          abbr: 'SEC',
        },*/
        {
          name: 'emergency_contact',
          capital: '',
          camel: 'emergencyContact',
          abbr: 'EC',
          single: '',
        }
      ],
      submitButtonCopy: 'Submit paperwork',
    }
  },
  computed: {
    studentsNames () {
      const studNames = this.students.map(student => student.name)
      if (!studNames) return
      if (studNames.length === 1) return studNames[0]
      if (studNames.length === 2) return studNames.join(' and ')
      return `${studNames.slice(0, -1).join(', ')}, and ${studNames.slice(-1)}`
    },
    studentsOver13 () {
      return this.students.filter(student => this.$getAge(student.birthday) > 13 || student.user_type.includes('ADULT_STUDENT'))
    },
    canSubmit () {
      const studentLiablityReleased = this.studentForms.every(form => form.media_liability_release)
      const mediaUseAnswered = this.studentForms.every(form => form.media_use_permission !== null)
      return studentLiablityReleased && mediaUseAnswered
    },
    containsYouthStudents () {
      let spottedAYouth = false
      this.students.forEach(student => {
        if (student.user_type.includes('ONLINE_STUDENT'))
          spottedAYouth = true
      })
      return spottedAYouth
    }
  },
  methods: {
    getEntities() {
      return new Promise(async resolve => {
        const usersRef = this.$firestore.collection('users')
        const guardianId = this.options.guardianId
        const [guardianSS, studentsQS] = await Promise
          .all([usersRef.doc(guardianId).get(), usersRef.where('guardian_id', '==', guardianId).get()])
        this.guardian = guardianSS.data()
        this.students = studentsQS.docs.map(doc => doc.data())
        console.log('guardianId',this.options.guardianId)
        console.log('guardian',this.guardian)
        if (this.guardian.user_type.includes('ADULT_STUDENT'))
          this.students.push(this.guardian)
        this.students.forEach(_ => this.studentForms.push(this.$clone(this.studentFormTemplate)))
        resolve()
      })
    },
    prepareForms () {
      if (this.students.length <= 1) return //nothing to prepare if only one student

      const formToCopy = this.studentForms[0] //will use the first form to copy from when guardian wants options to be shared

      //helper function that copys first forms input to all other forms
      const copyFieldToAll = field => this.students.forEach((_, studentIdx) => this.studentForms[studentIdx][field] = formToCopy[field])

      // if (!this.seeFields.address) copyFieldToAll('address')
      // if (!this.seeFields.primaryEmergency) copyFieldToAll('primary_contact')
      // if (!this.seeFields.secondaryEmergency) copyFieldToAll('secondary_contact')
      if (!this.seeFields.emergencyContact) copyFieldToAll('emergency_contact')
      //if (!this.seeFields.allowedPickups) copyFieldToAll('allowed_pickups')
    },
    getErrors () {
      const errors = []

      const getError = (student, idx, field) => {return this.$dig(this.formOptions, field.split('.'))(student) // this returns the formOptions
        .errorIf(this.$dig(this.studentForms[idx], field.split('.')))} // the returns the error

      const getErrorPrefix = (idx, isIndividual) => (this.students.length > 1) && isIndividual ? `Student #${idx + 1}: ` : ''

      // phone errors
      // this.students.forEach((student, idx) => {
      //   if (getError(student, idx, 'phone')) errors.push(`${getErrorPrefix(idx, true)}Input valid phone number for student.`)
      // })

      // address errors
      // this.students.forEach((student, idx) => {
      //   if (idx && !this.seeFields.address) return
      //   if (getError(student, idx, 'address')) errors.push(`${getErrorPrefix(idx, this.seeFields.address)}Input student address.`)
      // })

      // emergency contacts errors
      const emergencyContactFieldsAndErrors = { //coorelates fields to the type of error they should throw
        name: type => `Input emergency contact's name.`,
        relationship: type => `Input emergency contact's relationship.`,
        home_phone: type => `Input emergency contact's home phone.`,
        cell_phone: type => `Input emergency contact's cell phone.`,
        work_phone: type => `Input emergency contact's work phone.`,
        email: type => `Input emergency contact's email.`,
      }
      this.emergencyTypes.forEach(emergencyType => {
        this.students.forEach((student, idx) => {
          if (idx && !this.seeFields[emergencyType.camel]) return
          Object.keys(emergencyContactFieldsAndErrors).forEach(field => {
            if (getError(student, idx, `${emergencyType.name}.${field}`)) errors.push(`${getErrorPrefix(idx, this.seeFields[emergencyType.camel])}${emergencyContactFieldsAndErrors[field](emergencyType.name)}`)
          })
        })
      })

      // allowed pickups errors
      // const allowedPickupFieldsAndErrors = {
      //   name: pickupNum => `Please input name for allowed pickup #${pickupNum}`,
      //   phone: pickupNum => `Please input phone for allowed pickup #${pickupNum}`,
      //   relationship: pickupNum => `Please input relationship for allowed pickup #${pickupNum}`,
      // }

      // Array(2).fill().forEach((_, pickupIdx) => {
      //   this.students.forEach((student, studentIdx) => {
      //     if (studentIdx && !this.seeFields.allowedPickups) return
      //     Object.keys(allowedPickupFieldsAndErrors).forEach(field => {
      //       if (getError(student, studentIdx, `allowed_pickups.${pickupIdx}.${field}`)) errors.push(`${getErrorPrefix(studentIdx, this.seeFields.allowedPickups)}${allowedPickupFieldsAndErrors[field](pickupIdx + 1)}`)
      //     })
      //   })
      // })

      // parent must agree to conduct policy if there are kids
      if (!this.agreesToConductAndPolicy) errors.push('You must agree to the student conduct and discipline policy.')

      return errors.filter(Boolean)
    },
    async onSubmit () {
      if (this.submitButtonCopy !== 'Submit paperwork') return

      this.prepareForms()
      const errors = this.getErrors()
      if (errors.length) return errors.forEach(err => this.$toast({
        copy: err,
      }))

      //if (Date.now() > 1) return console.log(this.studentForms)

      this.submitButtonCopy = 'Loading...'

      const usersRef = this.$firestore.collection('users')

      const guardianUpdate = usersRef.doc(this.guardian.id).update({agreed_to_conduct_and_discipline_policy: Date.now()})
      const studentUpdates = this.students.map((student, studentIdx) => usersRef.doc(student.id).update({
        paperwork: this.studentForms[studentIdx],
        paperwork_complete: true,
      }))

      try {
        await Promise.all([guardianUpdate, ...studentUpdates])
      } catch (e) {
        console.error(e)
        this.$toast('Paperwork did not successfully save. Please try again.')
        this.submitButtonCopy = 'Submit paperwork'
        return
      }

      this.$toast('Paperwork successfully saved!')
      const user = (await this.$firestore.doc(`users/${this.guardian.id}`).get()).data()
      this.$store.commit('update', {user})
      this.$modals.hide('paperwork')

      const successFunc = this.options.onSuccess
      if (successFunc) successFunc()
    },
    populateForms() {
      this.students.forEach((student, idx) => {
        if (!student.paperwork_complete) return
        // fill in emergency contact
        Object.keys(student.paperwork.emergency_contact).forEach(key => {
          this.studentForms[idx].emergency_contact[key] = student.paperwork.emergency_contact[key]
          // compare to see if we need to check 'different contact for each'
          if (this.students.length > 0 && !this.seeFields.emergencyContact) {
            if (this.students[0].paperwork.emergency_contact[key] !== this.students[idx].paperwork.emergency_contact[key]) 
              this.seeFields.emergencyContact = true
          }
        })
        // fill in the rest of the paperwork fields
        const extraKeys = ['emergency_comments', 'media_use_permission', 'media_liability_release']
        extraKeys.forEach(key => {
          this.studentForms[idx][key] = student.paperwork[key]
        })
        // if the guardian has already filled out paperwork then they've already agreed to this
        this.agreesToConductAndPolicy = true
      }) 
    },
  },
  async mounted () {
    await this.getEntities()
    this.populateForms()
  },
}
</script>

<template lang="pug">
  #paperwork-main.modal-main
    .paperwork-container.modal-container
      .title Paperwork
      .content
        .paperwork-section
          .title Emergency Contact Information Form
          .subtitle This information will be extremely important in the event of an accident or medical emergency.
          .pro-form
            //.form-row
              .content-title Phone info
            //.form-row(
              v-for='(student, idx) in students'
              )
              pro-input(
                v-model='studentForms[idx].phone'
                :options='formOptions.phone(student)'
              )
            //.form-row
              .content-title Address info
            //.see-field-switch(
              v-if='students.length > 1'
              )
              input#address(
                v-model='seeFields.address'
                type='checkbox'
              )
              label(
                for='address'
              ) Use different addresses for each student?
            //.form-row(
              v-for='(student, idx) in students'
              v-if='!idx || seeFields.address'
              )
              pro-input(
                v-model='studentForms[idx].address'
                :options='formOptions.address(student)'
              )
            span(
              v-for='emergencyType in emergencyTypes'
            )
              .form-row
                .content-title {{emergencyType.capital}} Emergency Contact ({{emergencyType.abbr}})
              .see-field-switch(
                v-if='students.length > 1'
              )
                input(
                  :id='emergencyType.name'
                  v-model='seeFields[emergencyType.camel]'
                  type='checkbox'
                )
                label(
                  :for='emergencyType.name'
                ) 
                  //| Have different {{emergencyType.name}} emergency contact for each student?
                  | Have different emergency contact for each student?
              span(
                v-for='(student, idx) in students'
                v-if='!idx || seeFields[emergencyType.camel]'
              )
                .student-title(
                  v-if='seeFields[emergencyType.camel]'
                ) {{`${student.name}'s ${emergencyType.abbr}`}}
                .form-row(
                  v-for='(_, key) in studentFormTemplate[emergencyType.name]'
                )
                  pro-input(
                    v-model='studentForms[idx][emergencyType.name][key]'
                    :options='formOptions[emergencyType.name][key](student)'
                  )
            .content-title Comments
            .subtitle Please provide any additional information that would be beneficial for us to know.
            //.subtitle Please include any special medical or personal information you would want an emergency care provider to know – or special contact information.
            .form-row(
              v-for='(student, idx) in students'
            )
              pro-input(
                v-model='studentForms[idx].emergency_comments'
                :options='formOptions.emergency_comments(student)'
              )
        .paperwork-section
          .title Student Conduct and Discipline Policy
          .subtitle {{copy.opening}}
          .subtitle {{copy.unacceptable_behaviors.title}}
          ul
            li(
              v-for='behavior in copy.unacceptable_behaviors.behaviors'
            ) {{behavior}}
          .subtitle.italic.bold {{copy.unacceptable_behaviors.please_read}}
          .content-title {{copy.disruptive.title}}
          .subtitle {{copy.disruptive.explain}}
          ul
            li(
              v-for='behavior in copy.disruptive.behaviors'
            ) {{behavior}}
          //.content-title {{copy.intentional.title}}
          //.subtitle {{copy.intentional.explain}}
          .content-title {{copy.bullying.title}}
          .subtitle {{copy.bullying.explain}}
          ul
            li(
              v-for='example in copy.bullying.examples'
            ) {{example}}
          .subtitle {{copy.bullying.recap}}
          .content-title {{copy.phones.title}}
          .subtitle {{copy.phones.explain}}
          //- .subtitle.italic.no-space {{copy.phones.offense.title}}
          //- ul
          //-   li(
          //-     v-for='discipline in copy.phones.offense.disciplines'
          //-   ) {{discipline}}
          //.subtitle {{copy.phones.other_actions}}
          //.subtitle.italic.no-space {{copy.phones.device.title}}
          //.subtitle {{copy.phones.device.explain}}
          //.subtitle.italic.no-space {{copy.phones.charges.title}}
          //.subtitle {{copy.phones.charges.explain}}
          .content-title {{copy.discipline.title}}
          .subtitle {{copy.discipline.explain}}
          ul
            li(
              v-for='discipline in copy.discipline.disciplines'
            ) {{discipline}}
          .subtitle {{copy.discipline.fees}}
          .subtitle.italic {{copy.discipline.parent_interactions.title}}
          .subtitle(
            v-for='explanation in copy.discipline.parent_interactions.explanations'
          ) {{explanation}}
          .subtitle.center.bold {{copy.statement.title}}
          .subtitle(
            v-for='statement in copy.statement.statements'
          ) {{statement}}
          .subtitle(
            v-if='students.length > 1 || !guardian.user_type.includes("ADULT_STUDENT")'
          ) You are agreeing to this for {{studentsNames}}.
          .check-me
            .see-field-switch
              input#conduct-and-policy-agreement(
                v-model='agreesToConductAndPolicy'
                type='checkbox'
              )
              label(
                for='conduct-and-policy-agreement'
              ) I {{containsYouthStudents ? '(the parent/guardian of the aforementioned students)' : ''}} agree to the statements above.
        //.paperwork-section(
          v-if='agreesToConductAndPolicy'
          )
          .title {{copy.allergies.title}}
          .subtitle {{copy.allergies.instruction}}
          .pro-form
            .form-row(
              v-for='(student, idx) in students'
            )
              pro-input(
                v-model='studentForms[idx].allergies'
                :options='formOptions.allergies(student)'
              )
        .paperwork-section(
          v-if='agreesToConductAndPolicy'
        )
          .title {{copy.media_release.title}}
          .subtitle {{copy.media_release.guardian}}
          .subtitle {{copy.media_release.usage}}
          .subtitle {{copy.media_release.final}}

          .media-use-area
            .media-use(
              v-for='(form, idx) in studentForms'
            )
              .student-name.subtitle.bold For {{students[idx].name}}:
              .check-me
                .see-field-switch
                  input(
                    :id='`${idx}-media-use-true`'
                    v-model='studentForms[idx].media_use_permission'
                    type='radio'
                    :value='true'
                  )
                  label(
                    :for='`${idx}-media-use-true`'
                  ) Yes, I give South Bend Code School permission to use my student's photo/video for marketing the program.
              .check-me
                .see-field-switch
                  input(
                    :id='`${idx}-media-use-false`'
                    v-model='studentForms[idx].media_use_permission'
                    type='radio'
                    :value='false'
                  )
                  label(
                    :for='`${idx}-media-use-false`'
                  ) No, I do not give South Bend Code School permission to use my student's photo/video for marketing the program.

          .subtitle.bold {{copy.media_release.recordings}}
          .subtitle I release South Bend Code School from any and all liability that may arise in connection with such use for the following students:
          .check-me(
            v-for='(student, idx) in students'
          )
            .see-field-switch
              input(
                :id='`${student.id}-media-released`'
                v-model='studentForms[idx].media_liability_release'
                type='checkbox'
              )
              label(
                :for='`${student.id}-media-released`'
              ) {{student.name}}
        //.paperwork-section(
          v-if='agreesToConductAndPolicy'
          )
          .title {{copy.pickup.title}}
          .subtitle {{copy.pickup.explain}}
          .see-field-switch(
            v-if='students.length > 1'
          )
            input#other-pickup(
              v-model='seeFields.allowedPickups'
              type='checkbox'
            )
            label(
              for='other-pickup'
            ) Have different people allowed to pick up each student?
          .pro-form(
            v-for='(student, studentIdx) in students'
            v-if='!studentIdx || seeFields.allowedPickups'
          )
            span(
              v-for='(allowedPickups, pickupIdx) in studentForms[studentIdx].allowed_pickups'
            )
              .form-row
                .content-title Person {{`#${pickupIdx + 1}`}} {{seeFields.allowedPickups ? `who can pick up ${student.name}` : ''}}
              .form-row(
                v-for='(_, field) in studentForms[studentIdx].allowed_pickups[pickupIdx]'
              )
                pro-input(
                  v-model='studentForms[studentIdx].allowed_pickups[pickupIdx][field]'
                  :options='formOptions.allowed_pickups[pickupIdx][field]()'
                )
        //.paperwork-section(
          v-if='studentsOver13.length && agreesToConductAndPolicy'
          )
          .title {{copy.self_signout.title}}
          .subtitle {{copy.self_signout.explain}}
          .check-me(
            v-for='(student, idx) in studentsOver13'
          )
            .see-field-switch
              input(
                :id='`${student.id}-self-signout`'
                v-model='studentForms[idx].self_signout'
                type='checkbox'
              )
              label(
                :for='`${student.id}-self-signout`'
              ) {{student.name}}
      .action
        .button.minor(
          @click='$modals.hide(`paperwork`)'
        ) Cancel
        span
        .button.major(
          v-if='canSubmit'
          @click='onSubmit'
        ) {{submitButtonCopy}}
              
              
</template>

<style lang="sass" scoped>
  @import '$styles/form'
  #paperwork-main
    max-width: 600px
    .paperwork-container
      .action
        grid-template-columns: max-content auto max-content
        .button
          padding: 8px 24px
      .content
        max-height: calc(100vh - 96px)
        height: 500px
        padding: 24px 40px
        overflow: scroll
        .paperwork-section
          margin-bottom: 72px
          .title
            @extend .font-1-bold
            font-size: 24px
            padding: 8px 0
          .subtitle
            font-size: 14px
            margin-bottom: 16px
            &.italic
              font-style: italic
            &.bold
              font-weight: bold
            &.no-space
              margin-bottom: 4px
            &.center
              text-align: center
          .media-use-area
            .media-use
              .student-name
                font-size: 18px
          .student-title
            margin: 16px 0 8px
            font-family: $font-2
            font-size: 14px
          .see-field-switch
            display: grid
            grid-template-columns: 40px auto
            align-items: center
            cursor: pointer
            margin: 16px 0
            label
              cursor: pointer
              font-size: 14px
              user-select: none
            input
              height: 16px
              width: 16px
          ul
            margin-top: 4px
            > li
              font-size: 14px
          .check-me
            background-color: $mediumgrey
            padding: 16px
            margin-bottom: 16px
            border-radius: 4px
            font-weight: bold
</style>